export const getGender = (gender) => {
  if (gender === "Female") {
    return "F";
  } else {
    return "M";
  }
};
